import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/irin/Projects/Vieillir/vieillir-front/app/home.js");
